import { Injectable } from '@angular/core';
import { commentSample } from '../samples/comment.sample';
import { Observable } from 'rxjs';
import { DataApiService } from './data-api.service';
import { HttpClient } from '@angular/common/http';
import { UIService } from './ui.service';

@Injectable({
  providedIn: 'root',
})
export class CommentService extends DataApiService<any> {
  constructor(public httpClient: HttpClient, public uiService: UIService) {
    super(httpClient, uiService);
    this.setRootUrl('/api/pl/comment');
  }

  public getComments(): Observable<any> {
    return commentSample();
  }
}
